import dayjs from 'dayjs';

type DateTimeFormat = {
  datetime?: string;
  format?: string;
};

export const datetimeFormat = ({
  datetime,
  format = 'YYYY/MM/DD HH:mm:ss',
}: DateTimeFormat): string => {
  if (!datetime) {
    return '';
  }

  const d = dayjs(datetime);
  return d.format(format);
};

export const dateFormat = ({
  datetime,
  format = 'YYYY/MM/DD',
}: DateTimeFormat): string => {
  return datetimeFormat({ datetime, format });
};

export const dateTimeAtRequestFormat = (
  dateTime: number | string | undefined,
) => {
  if (typeof dateTime === 'undefined') {
    return;
  }
  return dayjs(dateTime).format('YYYYMMDDHHmmssSSS');
};

export const getCreatedMonthValueText = (
  value: [dayjs.Dayjs | undefined, dayjs.Dayjs | undefined] | null | undefined,
): string => {
  if (!value) {
    return '';
  }

  const [start, end] = value;
  if (!start && !end) {
    return '';
  }

  const startText = start ? start.format('YYYY-MM') : '';
  const endText = end ? end.format('YYYY-MM') : '';

  return `${startText}〜${endText}`;
};
